import {graphql} from '~/graphql-react-query/';

export const FilterQuery = graphql(`
    query FilterQuery(
        $input: FilterInputV2!
        $filter: FilterForFilteringFiltersV2
        $options: FilterOptions
    ) {
        filterV2 {
            filters(input: $input, filter: $filter, options: $options) {
                column
                pageInfo {
                    currentPage
                    hasNextPage
                    hasPreviousPage
                }
                items {
                    advertiserDomain {
                        id
                        name
                    }
                    publication {
                        id
                        name
                    }
                    publisher {
                        id
                        name
                    }
                    region {
                        id
                        name
                    }
                    mediaOwner {
                        id
                        name
                    }
                    mediaType {
                        id
                        name
                        canonicalName
                    }
                    changeset {
                        id
                        name
                        status
                    }
                    segment {
                        id
                        name
                        color
                        emailAlert
                        teamId
                        createdAt
                        updatedAt
                        sharing {
                            status
                            usersWithAccess {
                                id
                                name
                                email
                            }
                        }
                        author {
                            id
                            name
                            email
                        }
                    }
                    status {
                        id
                        name
                    }
                    placementType {
                        id
                        name
                    }
                }
            }
        }
    }
`);

export const CreativeAiFilters = graphql(`
    query CreativeAiFilters($input: FilterAiInputV2!, $filter: AiFilters) {
        aiEntities {
            filterAiEntitiesV2(input: $input, filter: $filter) {
                column
                pageInfo {
                    nextOffset
                    hasNextPage
                }
                items {
                    aiAdvertiserV1 {
                        name
                        hasAccess
                    }
                    aiCategoryV1 {
                        name
                        hasAccess
                    }
                    aiIndustryV1 {
                        name
                        hasAccess
                    }
                    aiProductV1 {
                        name
                        hasAccess
                    }
                }
            }
        }
    }
`);

export const MediaValueAiFilters = graphql(`
    query MediaValueAiFilters($input: MediaValueFilterInput!, $filter: MediaValueFilters) {
        mediaValueEntities {
            filterMediaValueEntities(input: $input, filter: $filter) {
                column
                pageInfo {
                    nextOffset
                    hasNextPage
                }
                items {
                    aiAdvertiserV1 {
                        name
                        hasAccess
                    }
                    aiCategoryV1 {
                        name
                        hasAccess
                    }
                    aiIndustryV1 {
                        name
                        hasAccess
                    }
                    aiProductV1 {
                        name
                        hasAccess
                    }
                }
            }
        }
    }
`);

export const GetEntitiesByIdQuery = graphql(`
    query GetEntitiesById($input: GetEntitiesByIdInput!) {
        filterV2 {
            getEntitiesById(input: $input) {
                adType {
                    id
                    name
                    canonicalName
                }
                brand {
                    id
                    name
                    industries {
                        id
                        name
                    }
                }
                industry {
                    id
                    name
                }
                category {
                    id
                    name
                    industry {
                        id
                        name
                    }
                }
                campaign {
                    id
                    name
                }
                publisher {
                    id
                    name
                }
                publication {
                    id
                    name
                }
                region {
                    id
                    name
                }
                product {
                    id
                    name
                    brand {
                        id
                        name
                    }
                }
                mediaOwner {
                    id
                    name
                }
                mediaType {
                    id
                    name
                    canonicalName
                }
                changeset {
                    id
                    name
                    status
                }
                segment {
                    id
                    name
                    color
                    emailAlert
                    teamId
                    createdAt
                    updatedAt
                    sharing {
                        status
                        usersWithAccess {
                            id
                            name
                            email
                        }
                    }
                    author {
                        id
                        name
                        email
                    }
                }
            }
        }
    }
`);

export const ConvertNamesToEntities = graphql(`
    query ConvertNamesToEntities($input: ConvertNameToEntitiesInput!) {
        filterV2 {
            convertNamesToEntities(input: $input) {
                adType {
                    id
                    name
                    canonicalName
                }
                brand {
                    id
                    name
                }
                industry {
                    id
                    name
                }
                mediaType {
                    id
                    name
                    canonicalName
                }
                region {
                    id
                    name
                }
                publisher {
                    id
                    name
                }
                publication {
                    id
                    name
                }
                mediaOwner {
                    id
                    name
                }
                mediaTypeSynonym {
                    id
                    name
                    canonicalName
                }
            }
        }
    }
`);

export const ConvertNameFiltersToIds = graphql(`
    query ConvertNameFiltersToIds($input: ConvertFiltersInput!) {
        filterV2 {
            convertNameFiltersToIds(input: $input) {
                adType
                brand
                category
                industry
                mediaType
                product
                region
            }
        }
    }
`);

export const GlobalMvFilterQuery = graphql(`
    query gmvFilterQuery(
        $country: SupportedCountry!
        $column: GlobalMediaValueInputColumn!
        $searchText: String
        $filter: GlobalMediaValueColumnFilter
        $size: Int
        $after: String
        $restrictedItemDisplayType: GlobalMediaValueRestrictedtemDisplayType
    ) {
        globalMediaValue {
            filterQuery(
                country: $country
                column: $column
                searchText: $searchText
                filter: $filter
                size: $size
                after: $after
                restrictedItemDisplayType: $restrictedItemDisplayType
            ) {
                items {
                    column
                    value
                    isLocked
                }
                after
            }
        }
    }
`);
